<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DColumnNameEditor',
  extends: compoment
}
</script>
